<template>
	<v-layout row justify-center>
		<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
			<v-card class="choose-address" style="position: relative;">
				<v-toolbar dense dark app flat color="primary">
					<v-btn icon small flat @click="closeDialog()">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title class="subheading">My Addresses</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat @click="saveCurrentAddress()">SAVE</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-content>
					<v-list three-line subheader>
						<v-radio-group v-model="selected_address">
							<div v-if="addresses.length" v-for="address in addresses">
								<v-list-tile @click="selectAddress(address)">
									<div>
										<v-radio :value="address" :ripple="false"></v-radio>
									</div>
									<div>
										<v-list-tile-title class="body-2">{{ address.name }}</v-list-tile-title>
										<v-list-tile-sub-title class="caption">{{ address.mobile_number }}</v-list-tile-sub-title>
										<v-list-tile-sub-title class="caption">{{ address.address }}, {{ address.barangay }}, {{ address.city }}, {{
											address.province }}, {{ address.region }} {{ address.postal_code }}</v-list-tile-sub-title>
									</div>
								</v-list-tile>
								<v-divider></v-divider>
							</div>
						</v-radio-group>
					</v-list>
				</v-content>
				<v-btn absolute dark fab top right color="secondary" style="bottom: 15px; top: auto; position: fixed;" @click="showNewAddress()">
					<v-icon>add</v-icon>
				</v-btn>
			</v-card>
		</v-dialog>
		<new-address :show="dialog_new_address" @hide="dialog_new_address = false"></new-address>
		<loader v-show="loading"></loader>
	</v-layout>
</template>

<script>
	export default {
		data() {
			return {
				notifications: false,
				sound: true,
				widgets: false,
				dialog: false,
				dialog_new_address: false,
				selected_address: null,
				addresses: [],
				loading: false
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			current_address: {
				// type: Any,
				default: null
			}
		},
		mounted() {
			this.onCloseNewAddress()
			this.onReloadAddresses()
		},
		methods: {
			closeDialog() {
				EventBus.$emit('myAddressesDialog', false);
			},
			onCloseNewAddress() {
				EventBus.$on('newAddressDialog', (res) => {
					this.dialog_new_address = res
				});
			},
			selectAddress(address){
				this.selected_address = address;
			},
			showNewAddress() {
				this.dialog_new_address = true
			},
			getAddresses() {
				this.loading = true
				var req_data = []
				axios.get('/api/users-addresses', req_data).then(res => {
						this.addresses = res.data.data.data
						this.selectPrimaryAddress();
						this.loading = false
						this.dialog_new_address = false
					})
					.catch(err => {
						this.toaster('something went wrong.', 201);
					})
					.finally(() => {});
			},
			selectPrimaryAddress() {
				this.addresses.map((value, index) => {
					if (value.primary == 1) {
						this.selected_address = value;
					}
				});
			},
			onReloadAddresses() {
				EventBus.$on('reloadAddresses', (res) => {
					this.getAddresses();
				});
			},
			saveCurrentAddress() {
				if (this.selected_address) {
					this.dialog = false;
					EventBus.$emit('saveCurrentAddress', this.selected_address);
				}
			}
		},
		watch: {
			show: {
				handler: function (after, before) {
					this.dialog = after
					if (after) {
						this.getAddresses()
					}
				},
				deep: true,
			},
			current_address: {
				handler: function (after, before) {
					this.selected_address = after;
				},
				deep: true,
			}
		}
	}

</script>

<style lang="scss">
	.choose-address {
		.v-input__control {
			width: 100%;
		}

		.v-input {
			margin: 0;
			padding: 0;
		}
	}
</style>
